<template>
  <b-card :class="'main'">
    <div>
      <router-link :to="{ name: 'Projects overview' }">
        <b-icon-arrow-left-circle></b-icon-arrow-left-circle>
        {{ $t('project_details.show_all') }}
      </router-link>
    </div>

    <h5>#{{ data.projectData.projectId }}</h5>
    <b-badge
      pill
      variant="light"
      v-if="data.createDate"
      class="p-2 mt-2 projectBadge"
      ><b-icon
        icon="person-plus-fill"
        aria-label="Published date"
        class="mr-1"
      />{{ data.createDate | dateReadable }}</b-badge
    >
    <h1 class="mt-2" v-if="Object.keys(data).length">
      {{ data.projectData.projectTitle }}
    </h1>
    <h3 v-if="Object.keys(data).length">
      {{
        data.status !== 'open'
          ? data.projectData.buyerName + ', ' + data.projectData.location
          : data.projectData.location
      }}
    </h3>
    <h4>
      <StatusIcon
        v-if="Object.keys(data).length"
        :status="data.status"
        :daysToExpired="data.daysToExpired"
        :key="data.status"
      />
    </h4>

    <ProjectDetails
      v-if="data.status === 'open' || data.status === 'invalid'"
      :id="data.projectData.projectId"
      :leadId="data.id"
      :status="data.status"
      :location="data.projectData.location"
      :currency="data.currency"
      :daysLeft="data.daysToExpired"
      :provisionPercent="data.provisionPercent"
      :expireFee="data.expireFee"
      :prePayment="data.prepayment"
      :leadPrice="data.leadprice"
    />

    <QuoteDetails
      v-if="
        data.status === 'won' ||
          data.status === 'quoted' ||
          data.status === 'lost' ||
          data.status === 'repwon' ||
          data.status === 'declined'
      "
      :id="parseInt(this.$route.params.id)"
      :status="data.status"
      :projectId="data.projectData.projectId"
      :vat="data.vat"
      :currency="data.currency"
      :buyerName="data.projectData.buyerName"
      :buyerEmail="data.projectData.buyerEmail"
      :buyerPhone="data.projectData.buyerPhone"
      :provisionPercent="data.provisionPercent"
      :debitDate="data.debitDate"
      @submit="redirectOverview"
    />

    <QuoteForm
      v-if="
        data.status === 'pending' ||
          data.status === 'quoted' ||
          data.status === 'expired'
      "
      :id="parseInt(this.$route.params.id)"
      :projectId="data.projectData.projectId"
      :status="data.status"
      :standalone="true"
      :extendable="data.extendable"
      :vat="data.vat"
      :currency="data.currency"
      :daysLeft="data.daysToExpired"
      :provisionPercent="data.provisionPercent"
      :expireFee="data.expireFee"
      :buyerName="data.projectData.buyerName"
      :location="data.projectData.location"
      :email="data.projectData.buyerEmail"
      :telephone="data.projectData.buyerPhone"
      :key="data.status"
      :complainable="data.complainable"
      @submit="updateData"
    />
  </b-card>
</template>
<script>
import api from '../api/api';
import StatusIcon from '@/components/StatusIcon.vue';
import QuoteForm from '@/components/QuoteForm.vue';
import QuoteDetails from '@/components/QuoteDetails';
import ProjectDetails from '@/components/ProjectDetails.vue';

export default {
  components: {
    StatusIcon,
    QuoteForm,
    QuoteDetails,
    ProjectDetails,
  },
  data() {
    return {
      data: [],
    };
  },
  mounted() {
    this.fetchProject();
  },
  metaInfo() {
    return {
      title: this.$t('quote_form.my_quote'),
    };
  },
  methods: {
    updateData() {
      setTimeout(() => this.fetchProject(), 5000);
    },
    reloadPage() {
      window && window.location.reload();
    },
    redirectOverview() {
      setTimeout(() => this.$router.push({ name: 'Projects overview' }), 5000);
    },
    fetchProject() {
      if (this.$route.params.method === 'edit') {
        api
          .getProvisionLead(this.$route.params.id)
          .then((res) => (this.data = res.data))
          .catch((err) => err);
      } else if (this.$route.params.method === 'show') {
        api
          .getOpenProvisionLead(this.$route.params.id)
          .then((res) => {
            if (res.data.success) {
              this.data = res.data.provisionLeadData;
            } else {
              if (res.data.reason === 'already_accepted') {
                api.getAnsweredLead(this.$route.params.id).then((lead) => {
                  this.$router.push({
                    name: 'View lead',
                    params: { id: lead.data.provisionLead.id, method: 'edit' },
                  });
                  setTimeout(() => this.reloadPage(), 2000);
                });
              } else {
                this.$router.push({
                  name: 'Invalid',
                  params: { reason: res.data.reason },
                });
              }
            }
          })
          .catch((err) => err);
      }
    },
  },
};
</script>
